module.exports = __webpack_public_path__ + "images/rich_heading/small_appliance/smart_phone/icon_1ae71c30437532a821e4e1b38db935aa.png";